import { useState } from "react";
import styles from "./style/answer_matrix.module.css";
import { useLanguage } from '../../functions/setGetLanguage';


const AnswerCheckbox = ({ choices, FunctionOnClick, submit}) => {
  const { language } = useLanguage();
  const [selected, setSelected] = useState([]);

  const selectOption = (choiceIndex) => {
    setSelected(prev => 
      prev.includes(choiceIndex)
        ? prev.filter(index => index !== choiceIndex)
        : [...prev, choiceIndex]
    );
    console.log(selected)
  };

  const submitAnswers = () => {
    if (selected.length < 1) return;
    const stacked = selected.map((i) => choices[i].store_variable);

    const payload = {
      ...submit,
      store_variable: {
        [submit.store_variable]: stacked,
      },
    };
    
    FunctionOnClick(payload);
  };

  return (
    <div className={styles.choices}>
      {choices.map((choice, i) => (
        <button
          key={i}
          className={`${styles.choiceButton} ${styles.choiceCheckmark} 
          ${selected.includes(i) ? styles.checkmarkActive : ""}`}
          onClick={() => selectOption(i)}
        >
          <div className={styles.checkmark}></div>
          {choice[`text${language}`]}
        </button>
      ))}
      <button
        className={styles.continue}
        onClick={() => submitAnswers()}
      >
        {submit[`text${language}`]}
      </button>
    </div>
    
  );
};

export default AnswerCheckbox;
